module.exports = __webpack_public_path__ + "static/11-ef2114674a5cc1346dd607240cf1d52e.png";